import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { IoIosArrowBack } from 'react-icons/io'
import { useSelector } from 'react-redux'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'

import { Button } from '../components/Button'
import { HeaderLogo } from '../components/HeaderLogo'
import { Input } from '../components/Input'
import { enterPassword } from '../helpers/validationSchema'
import { RootState, useAppDispatch } from '../store'
import { signUp } from '../store/actions/authActions'
import SignUpImage from '../assets/svg/SignupSVG.svg?react'

interface FormValues {
  password: string
}

export const EnterPassword = () => {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    resolver: yupResolver(enterPassword),
  })
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { loading, registrationSuccess } = useSelector(
    (state: RootState) => state.userReducer,
  )

  console.log('registrationSuccess', registrationSuccess)

  const email = searchParams.get('email') || ''
  const username = searchParams.get('userName') || ''

  const onSubmit = (data: FormValues) => {
    dispatch(
      signUp({
        email: email,
        password: data.password,
        username: username,
      }),
    ).then(() => {
      navigate('/')
    })
    reset()
  }

  return (
    <div className="flex font-sans">
      <div className="flex h-screen w-full flex-col px-6 py-6 sm:h-screen sm:w-[50%]">
        <HeaderLogo />
        <div className="flex h-screen flex-col justify-center w-full lg:w-[60%] mx-auto">
          <h2 className="mb-5 text-lg font-[500] text-primary text-center">
            {t('enterPassword')}
          </h2>
          <form
            className="flex flex-col"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Input
              variant={errors.password ? 'danger' : 'primary'}
              placeholder={t('passwordPlaceholder')}
              type="password"
              helperText={errors.password?.message}
              {...register('password')}
            />

            <Button
              text={t('continue')}
              type="submit"
              className="text-white"
              loading={loading}
            />
          </form>
          <Link className="mt-7 text-base text-secondary" to="/signup">
            <div className="flex items-center">
              <IoIosArrowBack />
              {t('btnBack')}
            </div>
          </Link>
        </div>
      </div>
      <div className="flex flex-col justify-center bg-[#407BFF] sm:h-screen sm:w-[50%]">
        <SignUpImage />
      </div>
    </div>
  )
}
